import GoogleMapReact from "google-map-react";
import React, { RefObject } from "react";

import { RestaurantItemType } from "../../../../api/types/restaurant.type";
import { useMap } from "../../../../store/map.context";
import MapMarker from "./MapMarker";

const key = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY;

const styleMap = [
  {
    featureType: "all",
    elementType: "labels.text.fill",
    stylers: [
      {
        saturation: 36,
      },
      {
        color: "#23241C",
      },
      {
        lightness: 10,
      },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.text.stroke",
    stylers: [
      {
        visibility: "off",
      },
      {
        lightness: 16,
      },
      // {
      //   color: "#eeeeee",
      // },
    ],
  },
  {
    featureType: "all",
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [
      // {
      //   color: "#eeeeee",
      // },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [
      {
        color: "#91769C",
      },
      // {
      //   lightness: 17,
      // },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        lightness: 20,
      },
      // {
      //   color: "#0F0F0F",
      // },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [
      // {
      //   color: "#eeeeee",
      // },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "geometry.fill",
    stylers: [
      // {
      //   color: "#070707",
      // },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      // {
      //   color: "#eeeeee",
      // },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      {
        color: "#E15582",
      },
      // {
      //   color: "#eeeeee",
      // },
      {
        lightness: 17,
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
      // {
      //   color: "#eeeeee",
      // },
      {
        saturation: "-2",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      // {
      //   color: "#eeeeee",
      // },
      {
        lightness: 18,
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry.fill",
    stylers: [
      // {
      //   color: "#eeeeee",
      // },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "geometry",
    stylers: [
      // {
      //   color: "#eeeeee",
      // },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "geometry",
    stylers: [
      // {
      //   color: "#0F0F0F",
      // },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        lightness: 17,
      },
      // {
      //   color: "#eeeeee",
      // },
    ],
  },
];
export const mapOptions:
  | GoogleMapReact.MapOptions
  | ((maps: GoogleMapReact.Maps) => GoogleMapReact.MapOptions)
  | undefined = {
  gestureHandling: "cooperative",
  scrollwheel: true,
  mapTypeControlOptions: {
    position: "BOTTOM_RIGHT",
  },
  draggable: true,
  rotateControl: true,
  scaleControl: true,
  streetViewControl: false,
  panControl: true,
  mapTypeControl: false,
  fullscreenControl: false,
  styles: styleMap,
};

export const defaultCenter = {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  lat: parseFloat(process.env.NEXT_PUBLIC_DEFAULT_MAP_LAT!),
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  lng: parseFloat(process.env.NEXT_PUBLIC_DEFAULT_MAP_LNG!),
};

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const defaultZoom = parseFloat(process.env.NEXT_PUBLIC_DEFAULT_MAP_ZOOM!);

interface Props {
  restaurants: RestaurantItemType[] | undefined;
  setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  inputRef?: RefObject<HTMLInputElement>;
}

const Map = ({ restaurants, setModalIsOpen, setIsOpen, inputRef }: Props) => {
  const { map } = useMap();

  return (
    <>
      {restaurants && (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: key as string,
          }}
          options={mapOptions}
          yesIWantToUseGoogleMapApiInternals
          center={{
            lat: map.lat,
            lng: map.lng,
          }}
          zoom={map.id !== -1 ? 10 : 6}
          defaultCenter={defaultCenter}
          defaultZoom={defaultZoom}
          resetBoundsOnResize
        >
          {restaurants &&
            restaurants.length > 0 &&
            restaurants.map((object, i) => (
              <MapMarker
                key={i}
                lat={object.latitude}
                lng={object.longitude}
                restaurantObject={object}
                setModalIsOpen={setModalIsOpen}
                setMenuSelectionIsOpen={setIsOpen}
                inputRef={inputRef}
              />
            ))}
        </GoogleMapReact>
      )}
    </>
  );
};

export default Map;
